import Vue from 'vue';
import {fetchData} from '../../utils';

export default {
    namespaced: true,

    state: {
        bannerData: {} // banner的数据
    },

    getters: {
        bannerData: state => state.bannerData
    },

    mutations: {
        setBannerData(state, data = {}) {
            state.bannerData = data;
        }
    },

    actions: {
        async requireBanner({commit, rootState}) {
            let url = '/feed-server/feed/feed_activity';
            try {
                const {uuid = '', source = '', xnryy = ''} = rootState.url.urlParams;
                const params = {
                    uuid,
                    source,
                    xnryy
                };
                return fetchData(url, {
                    method: 'post',
                    params
                }).then(res => {
                    const {errno, data} = res || {};
                    if (errno === 0) {
                        commit('setBannerData', data);
                    }
                });
            }
            catch (e) {
                new Vue().$toast({
                    message: '网络繁忙，请稍后再试'
                });
            }
        }
    }
};